<template>
  <v-dialog v-model="show" :max-width="width" persistent>
    <v-card>
      <v-card-title class="text-h6">
        <v-icon v-if="icon" left :color="color">{{ icon }}</v-icon>
        {{ title }}
      </v-card-title>
      <v-card-text class="pt-2" v-html="message"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="color" dark @click="close">{{ okText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      title: "Notice",
      message: "",
      okText: "OK",
      color: "primary",
      icon: "",
      width: 420,
      resolve: null,
    };
  },
  methods: {
    open(options = {}) {
      this.title = options.title || "Notice";
      this.message = options.message || "";
      this.okText = options.okText || "OK";
      this.color = options.color || "primary";
      this.icon = options.icon || "";
      this.width = options.width || 420;
      this.show = true;
      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },
    close() {
      this.show = false;
      if (this.resolve) this.resolve(true);
    },
  },
};
</script>
